import React from 'react';
import { Link } from 'react-router-dom';
import RoomBookingRulesModal from '../components/RoomBookingRulesModal';
// import Header from './Header';
// import Footer from './Footer';

const BookingSeva = () => {
  const [showRules, setShowRules] = React.useState(false);
  const [settings, setSettings] = React.useState({
    is_online_sevas_enabled: false,
    is_guru_seva_enabled: false,
    is_donation_enabled: false,
    is_room_booking_enabled: true
  });

  React.useEffect(() => {
    // Fetch global settings to determine active services
    fetch(`${process.env.REACT_APP_BACKEND_URL || ''}/api/settings`)
      .then(res => res.json())
      .then(data => {
        if (data && data.status === 'success' && data.data) {
          setSettings(data.data);
        }
      })
      .catch(err => console.error("Error fetching settings:", err));
  }, []);


  return (
    <>
      {/* <Header /> */}
      <section className="overflow-hidden">
        <div className="container" style={{ backgroundColor: '#e5e5e3' }}>
          <div className="title-area text-center">
            <span className="sub-title-img">
              <img src="assets/img/theme-img/title_shape.svg" alt="shape" />
            </span>
            <h2 className="sec-title text-anime-style-3">Online Services</h2>
            <span className="title-img">
              <img src="assets/img/theme-img/title_shape2.svg" alt="shape" />
            </span>
          </div>
          {/* Top Row: Room Booking (Always Centered) */}
          <div className="row text-center justify-content-center">
            {settings.is_room_booking_enabled !== false && (
              <div className="col-11 col-sm-8 col-md-4 col-xl-4 mb-4">
                <div className="service-card h-100">
                  <div className="box-content h-100 d-flex flex-column align-items-center">
                    <div className="box-icon">
                      <img src="assets/img/room_booking/rooms.png" alt="Room Booking" />
                    </div>
                    <h3 className="box-title mt-3">
                      <Link to="/bookingroom">Room Booking</Link>
                    </h3>
                    <p className="box-text flex-grow-1">
                      Experience peace and devotion during your visit by staying
                      within the serene premises of the temple. Comfortable and
                      well-maintained rooms are available for devotees.
                    </p>
                    <Link to="/bookingroom" className="line-btn mt-3">Read More</Link>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Middle Row: Online Sevas & Guru Seva */}
          <div className="row text-center justify-content-center">
            {settings.is_online_sevas_enabled && (
              <div className="col-11 col-sm-8 col-md-4 col-xl-4 mb-4">
                <div className="service-card h-100">
                  <div className="box-content h-100 d-flex flex-column align-items-center">
                    <div className="box-icon">
                      <img src="assets/img/room_booking/seva.png" alt="Online Sevas" style={{ height: '50px', width: '50px', objectFit: 'contain' }} />
                    </div>
                    <h3 className="box-title mt-3">
                      <Link to="/OnlineSevaBooking">Online Sevas</Link>
                    </h3>
                    <p className="box-text flex-grow-1">
                      Participate in divine sevas online from your home. Receive the blessings of
                      the almighty by contributing to the special pujas.
                    </p>
                    <Link to="/OnlineSevaBooking" className="line-btn mt-3">Read More</Link>
                  </div>
                </div>
              </div>
            )}

            {/* Empty Center Space: Render only if both side cards exist */}
            {settings.is_online_sevas_enabled && settings.is_guru_seva_enabled && (
              <div className="col-md-2 col-xxl-2 col-xl-2 mb-4 d-none d-md-block"></div>
            )}

            {settings.is_guru_seva_enabled && (
              <div className="col-11 col-sm-8 col-md-4 col-xl-4 mb-4">
                <div className="service-card h-100">
                  <div className="box-content h-100 d-flex flex-column align-items-center">
                    <div className="box-icon">
                      <img src="assets/img/room_booking/guru_seva.png" alt="Guru Seva" style={{ height: '50px', width: '50px', objectFit: 'contain' }} />
                    </div>
                    <h3 className="box-title mt-3">
                      <Link to="/gurusevabooking">Guru Seva</Link>
                    </h3>
                    <p className="box-text flex-grow-1">
                      Dedicated offerings and service to the Guru. Support the spiritual
                      initiatives and development projects guided by the Peetam.
                    </p>
                    <Link to="/gurusevabooking" className="line-btn mt-3">Read More</Link>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Bottom Row: Donation (Centered) */}
          <div className="row text-center justify-content-center">
            {settings.is_donation_enabled && (
              <div className="col-11 col-sm-8 col-md-4 col-xl-4 mb-4">
                <div className="service-card h-100">
                  <div className="box-content h-100 d-flex flex-column align-items-center">
                    <div className="box-icon">
                      <img src="assets/img/room_booking/hundi.png" alt="Donation" style={{ height: '50px', width: '50px', objectFit: 'contain' }} />
                    </div>
                    <h3 className="box-title mt-3">
                      <Link to="/bookingdonation">Donation</Link>
                    </h3>
                    <p className="box-text flex-grow-1">
                      Contribute towards temple development, annadana, goshala, and other noble
                      causes. Every contribution helps sustain our dharma programs.
                    </p>
                    <Link to="/bookingdonation" className="line-btn mt-3">Read More</Link>
                  </div>
                </div>
              </div>
            )}
          </div>

        </div>
      </section>
      {/* <Footer /> */}


    </>
  );
};

export default BookingSeva;


